import React from "react";
import { faceIcon } from "../../constants/Images";

export default function AtmCard() {
  return (
    <div className="atmcard">
      <div className="row align-items-center mb-2">
        <div className="col">
          <span className="atmcard_bankname">PAWNBROKER BANK</span>
        </div>
        <div className="text-right pr15px">
          <img className="atmcard_logo" src={faceIcon} alt="" />
        </div>
      </div>
      <div className="row mb-2">
        <div className="col">
          <span className="atmcard_label">CARD NUMBER</span>
          <span className="atmcard_controls">4177 21xx xxxx 0777</span>
        </div>
      </div>
      <div className="row align-items-center mb-2">
        <div className="col">
          <span className="atmcard_label">NAME ON CARD</span>
          <span className="atmcard_controls">John Wick</span>
        </div>
        <div className="pr15px">
          <span className="atmcard_label">VALIDITY</span>
          <span className="atmcard_controls">10/20</span>
        </div>
      </div>
      <div className="clearfix atmcard_button_group">
        <button className="atmcard_button">Edit</button>
        <button className="atmcard_button">Remove</button>
      </div>
    </div>
  );
}
